import { Map, fromJS } from 'immutable'
import { actions } from './actions'

const initialState = Map({
    cities: fromJS({
        countryCode: '',
        data: [],
    }),
    faqs: fromJS({
        params: {},
        data: [],
    }),
    setAddressLayout: null,
})

const content = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        // Cities
        case actions.GET_CITIES_SUCCESS: {
            return state.merge({
                cities: fromJS(payload),
            })
        }

        case actions.GET_CITIES_FAILED: {
            // default to empty city list
            return state.merge({
                cities: fromJS({
                    countryCode: '',
                    data: [],
                }),
            })
        }

        // FAQs
        case actions.GET_HOME_FAQS_SUCCESS: {
            return state.merge({
                faqs: fromJS(payload),
            })
        }

        case actions.GET_HOME_FAQS_FAILED: {
            // default to empty list
            return state.merge({
                faqs: fromJS({
                    params: {},
                    data: [],
                }),
            })
        }

        case actions.SET_ADDRESS_LAYOUT: {
            return state.merge({
                setAddressLayout: payload,
            })
        }

        default:
            return state
    }
}
export default content
